export const REMOVE_FILE_EXTENSION_REG_EXP = /\.[^/.]+$/;
export const FIND_UDERSCORE_REG_EXP = /_/g;
export const FIND_BR_TAGS = /<br\/>/g;
export const FIND_SPECIAL_CHARACTERS = /â/g;
